import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, ValidatorFn, Validators } from '@angular/forms';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.css'], // Asegúrate de que esté correcto
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextAreaComponent),
      multi: true,
    }
  ]
})
export class TextAreaComponent implements OnInit, ControlValueAccessor {
  @Input() label: string;
  @Input() required: boolean;
  @Input() formControlName: string;
  @Input() rows: number = 0;
  @Input() frm: FormGroup;
  @Input() readonly: boolean = false;
  @Input() min?: number; // Input opcional para el valor mínimo
  @Input() max?: number; // Input opcional para el valor máximo

  modelo: string = ''; // Asegúrate de que sea una cadena

  constructor() {}

  ngOnInit(): void {

    const control = this.frm.get(this.formControlName) as FormControl;

    if (control) {
      const validators: ValidatorFn[] = [];

      // Agregar el validador requerido si es necesario
      if (this.required) {
        validators.push(Validators.required);
      }

      // Agregar validadores de longitud mínima y máxima si están definidos
      if (this.min !== undefined) {
        validators.push(Validators.minLength(this.min)); 
      }
      if (this.max !== undefined) {
        validators.push(Validators.maxLength(this.max)); 
      }

      // Asignar validadores solo si hay validadores
      if (validators.length > 0) {
        control.setValidators(validators);
        control.updateValueAndValidity(); // Actualizar el control con los nuevos validadores
      }
    }  }

  onChange: any = () => {};
  onTouched: any = () => {};

  get value() {
    return this.modelo;
  }

  set value(val: string) {
    this.modelo = val;
    this.onChange(val);
    this.onTouched();
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  get ctrlInvalid() {
    return this.frm.controls[this.formControlName].invalid;
  }

  get ctrlTouched() {
    return this.frm.controls[this.formControlName].touched;
  }

  // Método para manejar el cambio en el textarea
  onInputChange(event: Event) {
    const target = event.target as HTMLTextAreaElement;
    this.value = target.value; // Actualiza el valor basado en el textarea
  }

  // Método para obtener la cantidad de caracteres escritos
  get currentLength() {
    return this.modelo ? this.modelo.length : 0;
  }
}
